import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { DeleteItemsModal } from 'ui/indexPages/modals/DeleteItemsModal';

import { FolderIdData, FolderNameData } from 'modules/domains/foldering';

import {
  ARCHIVE_MODAL_DISPLAY_TEXT,
  DELETE_MODAL_DISPLAY_TEXT,
  MIXED_MODAL_DISPLAY_TEXT,
} from '../constants';
import { WorkflowIdData, WorkflowNameData, WorkflowStatusData } from '../types';

const displayText = {
  enabledWarning: {
    singleEnabledWorkflow:
      'This journey is currently enabled. Archiving this journey will also disable it.',
    bulkSingleEnabledWorkflow:
      'One of these journeys is currently enabled. Archiving this journey will also disable it.',
    bulkSomeEnabledWorkflows:
      'Some of these workflows are currently enabled. Archiving these journeys will also disable them.',
    bulkAllEnabledWorkflows:
      'These journeys are currently enabled. Archiving these journeys will also disable them.',
  },
};

const EnabledWorkflowWarning = (props: {
  enabledWorkflowCount: number;
  totalWorkflowCount: number;
}) => {
  let warningText = displayText.enabledWarning.bulkAllEnabledWorkflows;
  if (props.enabledWorkflowCount === 1 && props.totalWorkflowCount === 1) {
    warningText = displayText.enabledWarning.singleEnabledWorkflow;
  } else if (props.enabledWorkflowCount === 1 && props.totalWorkflowCount > 1) {
    warningText = displayText.enabledWarning.bulkSingleEnabledWorkflow;
  } else if (
    props.enabledWorkflowCount > 1 &&
    props.enabledWorkflowCount < props.totalWorkflowCount
  ) {
    warningText = displayText.enabledWarning.bulkSomeEnabledWorkflows;
  }

  return (
    <Banner variant={BannerVariants.WARNING} data-test="enabled-workflow-warning">
      {warningText}
    </Banner>
  );
};

type DeleteItemsDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  workflowsBeingDeleted: (WorkflowIdData & WorkflowNameData & WorkflowStatusData)[];
  workflowsBeingArchived: (WorkflowIdData & WorkflowNameData & WorkflowStatusData)[];
  foldersBeingDeleted: (FolderIdData & FolderNameData)[];
};

export const DeleteItemsDialog = ({
  onClose,
  onConfirm,
  workflowsBeingArchived,
  workflowsBeingDeleted,
  foldersBeingDeleted,
}: DeleteItemsDialogProps) => {
  const enabledWorkflowCount = workflowsBeingArchived.filter(({ enabled }) => enabled).length;
  let displayContent = ARCHIVE_MODAL_DISPLAY_TEXT;
  if (workflowsBeingArchived.length === 0) displayContent = DELETE_MODAL_DISPLAY_TEXT;
  else if (workflowsBeingArchived.length !== 0 && workflowsBeingDeleted.length !== 0)
    displayContent = MIXED_MODAL_DISPLAY_TEXT;

  return (
    <DeleteItemsModal
      onClose={onClose}
      onConfirm={onConfirm}
      displayTextForContentItems={displayContent}
      content={[...workflowsBeingDeleted, ...workflowsBeingArchived]}
      folders={foldersBeingDeleted}
      warning={
        enabledWorkflowCount > 0 && (
          <EnabledWorkflowWarning
            enabledWorkflowCount={enabledWorkflowCount}
            totalWorkflowCount={workflowsBeingArchived.length}
          />
        )
      }
    />
  );
};
